import { object } from '@iwentsourcing/core/typing/object.js';
import { string } from '@iwentsourcing/core/typing/string.js';

export const AuthRefresh = object('AuthRefresh', {
  tenant: string(),
  realm: string(),
  provider: string(),
  username: string(),
  refreshToken: string(),
});
